import React from 'react';
import { Form, Input } from 'antd';
import moment from 'moment';
import PhotoUpload from '../../../../../common/components/UploadPhoto/UploadPhoto';
import { API_USER_PHOTO_UPLOAD } from '../../../api/constants';
const FormItem = Form.Item;

class autoCompleteFields extends React.Component {
  state = {
    avatarIsLoading: false,
  };
  // handleChangeAvatar = info => {
  //   const { avatarChange } = this.props;
  //   if (info.file.status === 'uploading') {
  //     this.setState({ avatarIsLoading: true });
  //     return;
  //   }
  //   if (info.file.status === 'done') {
  //     this.getBase64(info.file.originFileObj, imageUrl => {
  //       avatarChange(imageUrl);
  //       this.setState({
  //         avatarIsLoading: false,
  //       });
  //     });
  //   }
  // };

  render() {
    const { formState } = this.props;
    // const { avatarIsLoading } = this.state;
    let {
      lastname,
      name,
      patronymic,
      email,
      birth_date,
      birth_place,
      user_id,
    } = formState;
    let { avatar } = this.props;
    // avatar = avatar ? 'http://dev.teleportos.com' + avatar : null;
    return (
      <React.Fragment>
        <React.Fragment>
          <FormItem label="Фамилия" className="lastname">
            <Input
              disabled
              value={lastname}
              onChange={this.onChange}
              placeholder="Укажите фамилию"
            />
          </FormItem>
          <FormItem label="Имя" className="name">
            <Input
              disabled
              value={name}
              onChange={this.onChange}
              placeholder="Укажите имя"
            />
          </FormItem>
          <FormItem label="Отчество" className="name">
            <Input
              disabled
              value={patronymic}
              onChange={this.onChange}
              placeholder="Укажите отчество"
            />
          </FormItem>
          <FormItem label="Дата рождения" className="name">
            <Input
              disabled
              value={moment(birth_date).format('DD.MM.YYYY')}
              onChange={this.onChange}
              placeholder="Укажите дату рождения"
            />
          </FormItem>
          <FormItem label="Место рождения" className="name">
            <Input
              disabled
              value={birth_place}
              onChange={this.onChange}
              placeholder="Укажите место рождения"
            />
          </FormItem>
          <FormItem label="Email" className="name">
            <Input
              disabled
              value={email}
              onChange={this.onChange}
              placeholder="Укажите Email"
            />
          </FormItem>
          <div className="avatar-uploader">
            <PhotoUpload
              data={{ user_id: user_id }}
              // disabled={disabledAll}
              image_url={avatar}
              action={API_USER_PHOTO_UPLOAD}
            />
          </div>
        </React.Fragment>
      </React.Fragment>
    );
  }
}

export default autoCompleteFields;
